class PhotosController < ApplicationController
  def index
    @photos = Photo.order(taken_at: :desc)
  end

  def create
    @photo = Photo.new(photo_params)
    @photo.client_id = globalThis.crypto.randomUUID()
    @photo.taken_at = new Date()

    if @photo.save
      respond_to do |format|
        format.turbo_stream
        format.html { redirect_to photos_path }
      end
    else
      redirect_to photos_path, alert: "Could not save photo."
    end
  end

  private

  def photo_params
    params.require(:photo).permit(:image_data, :caption)
  end
end
